import {createReducer, on} from '@ngrx/store';
import {TermsAndConditionsActions} from '../actions/terms-conditions.actions';
import {
  fromTermsAndConditions,
  TermsAndConditionsCanonicalIdMap,
  termsAndConditionsFeatureKey,
  TermsAndConditionsState,
} from '../selectors/terms-conditions.selectors';

export interface TermsAndConditionsAppState {
  [termsAndConditionsFeatureKey]: TermsAndConditionsState;
}

const initialState: TermsAndConditionsState = {
  termsAndConditionsCanonicalIdMap: [],
};

export const termsAndConditionsReducer = createReducer<TermsAndConditionsState>(
  initialState,
  on(TermsAndConditionsActions.loaded, (state, {termsAndConditions, canonicalId}) => {
    const otherEntries = state.termsAndConditionsCanonicalIdMap.filter(
      (s) => !fromTermsAndConditions.compareCanonicalId(s.canonicalId, canonicalId)
    );
    return {
      termsAndConditionsCanonicalIdMap: [...otherEntries, {termsAndConditions, loadStatus: 'LOADED', canonicalId}],
    };
  }),
  on(TermsAndConditionsActions.setLoadingState, (state, {canonicalId}) => {
    const found = state.termsAndConditionsCanonicalIdMap.find((s) =>
      fromTermsAndConditions.compareCanonicalId(s.canonicalId, canonicalId)
    );
    const otherEntries = state.termsAndConditionsCanonicalIdMap.filter(
      (s) => !fromTermsAndConditions.compareCanonicalId(s.canonicalId, canonicalId)
    );
    return {
      termsAndConditionsCanonicalIdMap: [
        ...otherEntries,
        {termsAndConditions: found?.termsAndConditions, loadStatus: 'LOADING', canonicalId},
      ],
    };
  }),
  on(TermsAndConditionsActions.initMap, (state, {canonicalId}) => {
    const termsAndConditionsCanonicalIdMap: TermsAndConditionsCanonicalIdMap = {
      canonicalId,
      loadStatus: 'NOT_LOADED',
      termsAndConditions: [],
    };
    return {
      termsAndConditionsCanonicalIdMap: [...state.termsAndConditionsCanonicalIdMap, termsAndConditionsCanonicalIdMap],
    };
  }),
  on(TermsAndConditionsActions.loadFailure, (state, {error, canonicalId}) => {
    const otherEntries = state.termsAndConditionsCanonicalIdMap.filter(
      (s) => !fromTermsAndConditions.compareCanonicalId(s.canonicalId, canonicalId)
    );
    return {
      termsAndConditionsCanonicalIdMap: [
        ...otherEntries,
        {canonicalId, error, loadStatus: 'ERROR', termsAndConditions: []},
      ],
    };
  }),
  on(TermsAndConditionsActions.resetMap, (state, {canonicalId}) => {
    const otherEntries = state.termsAndConditionsCanonicalIdMap.filter(
      (s) => !fromTermsAndConditions.compareCanonicalId(s.canonicalId, canonicalId)
    );
    const termsAndConditionsCanonicalIdMap: TermsAndConditionsCanonicalIdMap = {
      canonicalId,
      loadStatus: 'NOT_LOADED',
      termsAndConditions: [],
    };
    return {
      termsAndConditionsCanonicalIdMap: [...otherEntries, termsAndConditionsCanonicalIdMap],
    };
  })
);
